import { createFileRoute } from '@tanstack/react-router';
import { CampaignExperimentDetailRoute } from './-route-wrappers';

function AutomationsOverviewTestsExperimentRoute() {
  const { campaignId, experimentId } = Route.useParams();

  return (
    <CampaignExperimentDetailRoute campaignId={campaignId} experimentId={experimentId} campaignPath="automations" />
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/experiments/$experimentId',
)({
  component: AutomationsOverviewTestsExperimentRoute,
});
